module.exports = __webpack_public_path__ + "static/media/working.43015434.gif";